import { Injectable, SimpleChanges } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UtilitiesService } from "./utilities.service";

@Injectable({
    providedIn: 'root'
})
export class LibTabService {
    constructor(
        public router: Router,
        public utilitiesService: UtilitiesService,
        public activatedRoute: ActivatedRoute
    ) {}

    redirectToCoreTabOnChange(changes: SimpleChanges) {
        // reacts to product id changing while the tab is open
        const idChange = changes['id'];

        if (idChange && idChange.firstChange == false && idChange.currentValue != idChange.previousValue) {
            // when we reload the page for the selected product pim loads with the core tab selected by default 
            this.router.navigate([`../core`], this.utilitiesService.buildNavExtras(this.activatedRoute, null, true));
            window.location.reload();
        }
    }
}